<template>
    <div v-if="data" class="task-card_wrap flex flex-col justify-between p-5 bg-white rounded-xl min-h-52 mb-5 last:mb-0 ">
        <div class="flex flex-col">
            <div class="flex items-center justify-between mb-3 relative">
                <span :class="['priority bg-opacity-10 text-xxs font-medium px-2 py-1 rounded-xl uppercase tracking-wider ', colors[data.priority.toLowerCase()]]">
                    {{ data.priority }}
                </span>
                <DropdownMenu v-if="user.profile.account_type == 'client'" >
                    <DropdownItem @click="$emit('openDialog', 'update', true , data)" name="Edit Task"   />
                    <DropdownItem @click="$emit('openDialog', 'delete', true , data)" name="Delete"/>
                </DropdownMenu>
            </div>
            <div @click="$emit('openDialog', 'view', true,data)" >
                <h4 class="font-medium text-darkgray cursor-pointer mb-2" >{{ data.name }}</h4>
                <p class="text-sm cursor-pointer line-clamp-3">{{ data.note }}</p>
            </div>
            <div v-if="user.profile.account_type != 'client' && data.va_id == user.profile.id " class="text-xs mt-4">
                <p class="mb-2 text-themegray">Change Status</p>
                <div class="relative">
                    <select name="" id="" class="block w-full px-3 py-3 appearance-none bg-white border border-1 focus:outline-none rounded-md" v-model="taskStatus" @change="selectValueChange" >
                        <option value="todo">Todo</option>
                        <option value="inprogress">In Progress</option>
                        <option value="completed">Completed</option>
                    </select>
                    <Icon name="mynaui:chevron-down" size="16" class="absolute top-1/2 -translate-y-1/2 right-3 pointer-events-none"/>
                </div>
            </div>
        </div>
        <div class="mt-5 pt-3 flex justify-between items-center border-t border-lightgray">
            <p class="text-sm block font-medium text-darkgray">{{ dayjs(data.created_at).format('MMMM D, YYYY')  }}</p>
            <p class="text-sm block font-medium text-secondary/80">{{ dayjs(data.due_on).format('MMMM D, YYYY')  }}</p>
            <!-- <img :src="data.image" class="h-8 w-8 rounded-full object-cover block" alt=""> -->
        </div>
    </div>
    <div v-else class="task-card_wrap p-5 border border-dashed border-themegray text-themegray rounded-xl min-h-52 grid place-items-center last:mb-0">
        No task available
    </div>
</template>

<script setup>

const {updateTask} = await useTask()

const props = defineProps({
    data: {
        type: Object,
        default: () => { },
        required: true
    }
})
const dayjs = useDayjs()
const user = useUserStore()

const colors = {
    "low": "text-complete bg-complete",
    "medium": "text-inprogress bg-inprogress",
    "high": "text-overdue bg-overdue"
}

const taskStatus = ref('')

taskStatus.value = props.data.status

const selectValueChange = async (e) => {
    const taskId = props.data.id
    await updateTask(taskId,{status:taskStatus.value})
    return
}
const truncateString = (str, firstCharCount = str.length, endCharCount = 0, dotCount = 3) => {
  if (str.length <= firstCharCount + endCharCount) {
    return str; // No truncation needed
  }

  const firstPortion = str.slice(0, firstCharCount);
  const endPortion = str.slice(-endCharCount);
  const dots = '.'.repeat(dotCount);

  return `${firstPortion}${dots}${endPortion}`;
}

</script>